import React, { ReactNode } from 'react';
import Button from 'app/components/Button/base';

const PrimaryButton = ({
  label,
  onClick,
  disabled,
  className,
}: {
  label: string | ReactNode;
  onClick: (e) => void;
  disabled?: boolean;
  className?: string;
}) => (
  <Button
    label={label}
    onClick={onClick}
    disabled={disabled}
    className={`px-4 py-2  ${className ? className : ''} ${
      disabled ? 'bg-slate-600' : ''
    } inline-flex items-center h-10 justify-center howio-font-md rounded-full `}
  ></Button>
);

export default PrimaryButton;
